import React, { useState, useEffect } from 'react';
import Field from './Field';
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const isEmailValid = (email) => {
    return email.match(EMAIL_REGEX) !== null;
};
export const EmailField = (props) => {
    const { label, id, autoComplete, fieldSx, name, value, disabled, required } = props;
    const [email, setEmail] = useState('');
    const [validEmail, setValidEmail] = useState(false);
    const onChange = props.onChange;
    useEffect(() => {
        if (value !== undefined) {
            setEmail(value);
        }
    }, [value]);
    useEffect(() => {
        const valid = isEmailValid(email);
        if (valid) {
            onChange(email);
        }
        else {
            onChange(undefined);
        }
        setValidEmail(valid);
    }, [email, onChange]);
    const handleInputChange = (event) => {
        setEmail(event.target.value);
    };
    return (React.createElement(Field, { required: required, name: name ? name : 'email', id: id ? id : undefined, autoComplete: autoComplete ? autoComplete : 'autoComplete', error: email.trim().length > 0 && !validEmail, errorText: (email.trim().length > 0 && !validEmail && 'Felaktigt format') || undefined, disabled: disabled, label: label, sx: fieldSx, value: email, onChange: handleInputChange, placeholder: "Fyll i e-mail", type: "email" }));
};
export default EmailField;
